import { Component, Injector, ViewEncapsulation, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import {
    OrderGuideServiceProxy,
    OrderGuideDto,
    OrderGuideForViewDto,
    BasketInputDto,
    IBasketInputDto,
    OrderScheduleServiceProxy,
    PagedResultDtoOfOrderScheduleDto,
    OrderScheduleDto
} from '@shared/service-proxies/service-proxies';
import { NotifyService } from 'abp-ng2-module';
import { AppComponentBase } from '@shared/common/app-component-base';

import { appModuleAnimation } from '@axilla/axilla-shared';
import * as _ from 'lodash-es';
import moment from 'moment';
import { filter, finalize } from 'rxjs/operators';

import { Table } from 'primeng/table';
import { Paginator } from 'primeng/paginator';
import { LazyLoadEvent } from 'primeng/api';

import { WebshopService } from '@app/shared/common/shop-system/services/webshop.service';

import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

@Component({
    templateUrl: './order-overview.component.html',
    styleUrls: ['./order-overview.component.less'],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()]
})
export class OrderOverviewComponent extends AppComponentBase implements OnInit {
    @ViewChild('dataTable', { static: true }) dataTable: Table;
    @ViewChild('paginator', { static: true }) paginator: Paginator;


    orderForm: UntypedFormGroup;

    constructor(
        injector: Injector,
        private _orderScheduleService: OrderScheduleServiceProxy,
        private _notifyService: NotifyService,
        private _activatedRoute: ActivatedRoute,
        private _router: Router,

        private _webshopService: WebshopService
    ) {
        super(injector);
    }


    ngOnInit(): void {
        this._initOrderSearchForm();

        if (this.isOuBlocked) {
            this.showIsBlockedMessage();
        } else {
            this.checkIsOuBlocked();
        }
    }

    private _initOrderSearchForm() {
        this.orderForm = new UntypedFormGroup({
            patient: new UntypedFormControl(null),
            article: new UntypedFormControl(null),
            status: new UntypedFormControl(null),
            startDate: new UntypedFormControl(null),
            endDate: new UntypedFormControl(null),
        });
    }

    getTotal(orderSchedule: OrderScheduleDto) {
        let total = 0;
        orderSchedule.orderItems.forEach(function(x) {
            total += x.price;
        }.bind(this));

        return total.toFixed(2);
    }

    getOrders(event?: any) {
        this.primengTableHelper.showLoadingIndicator();

        this._orderScheduleService.getPagedAndFilteredResultOrderSchedule(
                undefined,
                this.orderArticle || undefined,
                this.orderStatus || undefined,
                this.orderStartDate || undefined,
                this.orderEndDate || undefined,
                this.primengTableHelper.getSorting(this.dataTable) || 'lastModificationTime desc',
                this.primengTableHelper.getMaxResultCount(this.paginator, event),
                this.primengTableHelper.getSkipCount(this.paginator, event))
            .pipe(
                finalize(() => this.primengTableHelper.hideLoadingIndicator())
            )
            .subscribe((result: PagedResultDtoOfOrderScheduleDto) => {
                this.primengTableHelper.totalRecordsCount = result.totalCount;
                this.primengTableHelper.records = result.items;
                this.primengTableHelper.hideLoadingIndicator();
            });

        this.primengTableHelper.hideLoadingIndicator();
    }

    openEditOrder(orderId) {

    }


    deleteOrder(orderId) {
        this._orderScheduleService.delete(orderId)
            .subscribe(() => {
                this.getOrders();
            });
    }

    openDetails(item: any) {
        if (item.data.type === 'Order') {
            this._router.navigate(['/app/webshop/order-details/' + item.data.id]);
        }
    }


    //#region search form related fields
    get orderArticle() {
        if (this.orderForm) {
            let article = this.orderForm.get('article').value;
            if (article != null && article.id) {
                return `${article.code}-${article.title}`;
            }
            return article;
        }
        return '';
    }

    get orderStatus() {
        if (this.orderForm) {
            return this.orderForm.get('status').value;
        }
        return '';
    }

    get orderPatient() {
        if (this.orderForm) {
            return this.orderForm.get('patient').value;
        }
        return '';
    }
    get orderStartDate() {
        if (this.orderForm) {
            return this.orderForm.get('startDate').value;
        }
        return '';
    }
    get orderEndDate() {
        if (this.orderForm) {
            return this.orderForm.get('endDate').value;
        }
        return '';
    }

    //#endregion search form related fields

}
